import { Injectable } from '@nestjs/common';
import { HlPercentage } from '../hl-percentage.entity';
import { HlPercentageDTO } from './hl-percentage.dto';



@Injectable()
export class HlPercentageAdapter {
  
  public convertDtoToEntity(hlPercentageDTO: HlPercentageDTO,  isUpdate: boolean = false ): HlPercentage {
    const hlPercentage = new HlPercentage();
    hlPercentage.hlPercentageId=hlPercentageDTO.hlPercentageId;
    hlPercentage.minGrade=hlPercentageDTO.minGrade;
    hlPercentage.maxGrade=hlPercentageDTO.maxGrade;
    hlPercentage.hlPercentage=hlPercentageDTO.hlPercentage;
    hlPercentage.type = hlPercentageDTO.type
    // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
    hlPercentage.isActive=hlPercentageDTO.isActive==undefined?true:hlPercentageDTO.isActive;
    if (isUpdate) {
        hlPercentage.updatedUser = hlPercentageDTO.updatedUser;
    } else {
        hlPercentage.isActive = true;
        hlPercentage.createdUser = hlPercentageDTO.createdUser;
    }
   return hlPercentage;
  }
  public convertEntityToDto(hlPercentageObject: HlPercentage): HlPercentageDTO {
    const hlPercentageDto= new HlPercentageDTO;
    hlPercentageDto.hlPercentageId=hlPercentageObject.hlPercentageId;
    hlPercentageDto.minGrade=hlPercentageObject.minGrade;
    hlPercentageDto.maxGrade=hlPercentageObject.maxGrade;
    hlPercentageDto.hlPercentage=hlPercentageObject.hlPercentage;
    hlPercentageDto.isActive = hlPercentageObject.isActive;
    hlPercentageDto.createdAt = hlPercentageObject.createdAt;
    hlPercentageDto.updatedAt = hlPercentageObject.updatedAt;
    hlPercentageDto.createdUser = hlPercentageObject.createdUser;
    hlPercentageDto.updatedUser = hlPercentageObject.updatedUser;
    hlPercentageDto.versionFlag = hlPercentageObject.versionFlag;
    hlPercentageDto.type = hlPercentageObject.type
    return hlPercentageDto;
  }
}
